import moment from "moment-timezone";

export default function(val) {
  return moment.tz(new Date(val), 'EST').format('L')
}
